import { useState } from "react";
import "../feature/feature.css";
import { toast } from "react-toastify";
import ApiRequest from "../../helper/ApiRequest";
import { useNavigate } from "react-router-dom";

export default function AddPrice() {
  const navigate = useNavigate();
  const [pricing, SetPricing] = useState({
    plans: [
      {
        professional_extra_feature: "",
        expert_extra_feature: "",
        super_app_extra_feature: "",
        plan_points: [
          {
            point: "",
            starting_up: "",
            professional: "",
            expert: "",
            super_app: ""
          }
        ]
      }
    ]
  });

  const handleExtraFeatureChange = (field, value) => {
    SetPricing(prev => {
      const updated = { ...prev };
      updated.plans[0][field] = value;
      return updated;
    });
  };

  const handlePlanPointChange = (index, field, value) => {
    SetPricing(prev => {
      const updated = { ...prev };
      updated.plans[0].plan_points[index][field] = value;
      return updated;
    });
  };

  const addPlanPoint = () => {
    SetPricing(prev => {
      const updated = { ...prev };
      updated.plans[0].plan_points.push({
        point: "",
        starting_up: "",
        professional: "",
        expert: "",
        super_app: ""
      });
      return updated;
    });
  };

  const removePlanPoint = (index) => {
    SetPricing(prev => {
      const updated = { ...prev };
      updated.plans[0].plan_points.splice(index, 1);
      return updated;
    });
  };

  const validatePricing = (pricing) => {
    const plan = pricing.plans[0];

    // 1. Check top-level extra feature fields
    if (
      !plan.professional_extra_feature.trim() ||
      !plan.expert_extra_feature.trim() ||
      !plan.super_app_extra_feature.trim()
    ) {
      return false;
    }

    // 2. Check each plan point
    for (const point of plan.plan_points) {
      // Point name must be filled
      if (!point.point.trim()) {
        return false;
      }

      // Check dropdown values for each field
      for (const key of ["starting_up", "professional", "expert", "super_app"]) {
        const value = point[key];

        // If empty -> invalid
        if (value === "") {
          return false;
        }

        // If 'content' is selected but no extra text entered -> invalid
        if (value === "content" || (typeof value === "string" && value !== "true" && value !== "false")) {
          if (!value.trim() || value === "content") {
            return false;
          }
        }
      }
    }

    return true;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validatePricing(pricing)) {
      toast.error("All fields are mandatory!");
      return;
    }

    try {
      const response = await ApiRequest("POST", "api/plan/store", pricing);
      if (response.error === true) {
        toast.error(response.message)
      } else {
        toast.success(response.message)
        navigate("/admin/price");
      }
    } catch (error) {
      console.error("There was an error creating the price!", error);
      alert("There was an error creating the Pricing!");
    }
  };

  return (
    <>
      <div className="header-add-category">
        <h5>Add Pricing</h5>
      </div>
      <div className="add-feature-content">
        <form onSubmit={handleSubmit}>
          {/* <label>StartUp Extra Plans*:</label>
          <input type="text" name="starting_up_extra_feature" required className="form-control" value={pricing.plans[0].starting_up_extra_feature} onChange={(e) => handleExtraFeatureChange("starting_up_extra_feature", e.target.value)} /> */}
          <h6>Extra Plans</h6>
          <div style={{ position: "relative", border: "1px solid #ccc", padding: "10px", borderRadius: "8px", marginBottom: "12px" }}>
            <label>Professional Extra Plans*:(comma-separated)</label>
            <input type="text" name="professional_extra_feature" required className="form-control" value={pricing.plans[0].professional_extra_feature} onChange={(e) => handleExtraFeatureChange("professional_extra_feature", e.target.value)} />

            <label>Expert Extra Plans*:(comma-separated)</label>
            <input type="text" name="expert_extra_feature" required className="form-control" value={pricing.plans[0].expert_extra_feature} onChange={(e) => handleExtraFeatureChange("expert_extra_feature", e.target.value)} />

            <label>SuperApp Extra Plans*:(comma-separated)</label>
            <input type="text" name="super_app_extra_feature" required className="form-control" value={pricing.plans[0].super_app_extra_feature} onChange={(e) => handleExtraFeatureChange("super_app_extra_feature", e.target.value)} />
          </div>

          <div style={{ marginTop: "30px" }}>
            <h6>Plan Points</h6>
            {pricing.plans[0].plan_points.map((pointObj, index) => (
              <div key={index} className="plan-point-box" style={{ position: "relative", border: "1px solid #ccc", padding: "10px", borderRadius: "8px", marginBottom: "12px" }}>
                <h6>Plan Point {index + 1}</h6>

                {/* Remove button top right */}
                {pricing.plans[0].plan_points.length > 1 && (
                  <button type="button" className="btn btn-danger" style={{ position: "absolute", top: "10px", right: "10px" }} onClick={() => removePlanPoint(index)}>
                    X
                  </button>
                )}

                {/* Always show Point Name input */}
                <label>Point Name:*</label>
                <input type="text" className="form-control" value={pointObj.point} onChange={(e) =>
                  handlePlanPointChange(index, "point", e.target.value)} />

                {/* Dropdowns for the four plan fields */}
                {["starting_up", "professional", "expert", "super_app"].map((field) => {
                  const value = pointObj[field];
                  const dropdownValue = value === true ? "true" : value === false ? "false" : value === "" ? "" : "content";
                  return (
                    <div key={field} className="dropdown-section mt-2">
                      <label>{field.replace("_", " ") + "*"}:</label>
                      <select className="form-control" value={dropdownValue}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === "true") handlePlanPointChange(index, field, true);
                          else if (val === "false") handlePlanPointChange(index, field, false);
                          else if (val === "content") handlePlanPointChange(index, field, "content");
                          else handlePlanPointChange(index, field, "");
                        }}
                      >
                        <option value="">select</option>
                        <option value="true">True</option>
                        <option value="false">False</option>
                        <option value="content">Content</option>
                      </select>

                      {/* Show input only if "content" is selected */}
                      {dropdownValue === "content" && (
                        <input type="text" className="form-control mt-1" placeholder={`Enter ${field} content`} value={typeof value === "string" && value !== "content" ? value : ""} onChange={(e) =>
                          handlePlanPointChange(index, field, e.target.value)} />
                      )}
                    </div>
                  );
                })}
              </div>
            ))}

            <div className="addmore-feature">
              <button type="button" onClick={addPlanPoint} className="btn btn-primary mt-3" >
                +
              </button>
            </div>
          </div>

          <div style={{ textAlign: "center" }}>
            <button type="submit" className="default-btn">
              Submit
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
